/** Route segment for `/event-networking/:eventId` (public, no auth). */
export const EVENT_NETWORKING = 'event-networking';

/** True when the path is a public event-networking detail URL (any base path prefix). */
export function isEventNetworkingPublicUrl(url: string): boolean {
  if (!url) {
    return false;
  }
  const segments = url.split('?')[0].split('/').filter(Boolean);
  const i = segments.indexOf(EVENT_NETWORKING);
  return i >= 0 && segments[i + 1] != null && segments[i + 1].length > 0;
}
